var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96549 4.49001L5.13849 5.23201C5.24781 5.60619 5.40051 5.9663 5.59349 6.30501C5.79478 6.64124 6.03733 6.95098 6.31549 7.22701L7.38649 6.89701C7.98649 6.71201 8.64149 6.90201 9.04049 7.37701L9.65049 8.10301C9.89747 8.39445 10.0213 8.7706 9.99571 9.15176C9.97014 9.53293 9.79718 9.88916 9.51349 10.145C8.51849 11.053 6.98649 11.36 5.83949 10.459C4.83096 9.66574 3.97793 8.69269 3.32349 7.58901C2.66739 6.49075 2.22811 5.2768 2.02949 4.01301C1.80949 2.59101 2.85049 1.45301 4.14849 1.06501C4.92249 0.833007 5.74849 1.23101 6.03249 1.97301L6.36749 2.84801C6.58749 3.42401 6.42949 4.07401 5.96549 4.49001Z",
    fill: "#1C7A04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.0fb8b112d98af78d9bb731247021e219.svg";
export { ForwardRef as ReactComponent };